import { FilterModalProps } from "@/lib/centra/hooks/usePlp";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import styles from "../index.module.css";
type Props = {
  filters: FilterModalProps;
};

const FilterModalContent = ({ filters }: Props) => {
  const t = useTranslations();
  const { filterObjects, clearFilters } = filters;

  const allCleared = useMemo(() => {
    return filterObjects?.every(group =>
      group.filters.every(f => f.active === false),
    );
  }, [filterObjects]);

  const messages = useMemo(() => {
    return {
      herre: t("product.filter.herre"),
      dame: t("product.filter.dame"),
      unisex: "Unisex",
    };
  }, [t]);

  return (
    <>
      <div onClick={clearFilters} className={styles.filterButton}>
        <label htmlFor="gender">
          <input
            className={styles.filterInput}
            onChange={() => clearFilters()}
            checked={allCleared}
            type="radio"
            name="gender"
            value="all"
          />
          <span>{t("product.filter.all")}</span>
        </label>
      </div>
      {filterObjects?.map(filterObj =>
        filterObj.filters.map(filter => (
          <div
            onClick={() => filter.toggle()}
            key={filter.value}
            className={styles.filterButton}
          >
            <label htmlFor={filter.value}>
              <input
                className={styles.filterInput}
                onChange={() => filter.toggle()}
                checked={filter.active}
                type="radio"
                name={filterObj.name}
                value={filter.value}
              />
              <span>
                {messages[filter.value.toLowerCase() as keyof typeof messages]}
              </span>
            </label>
          </div>
        )),
      )}
    </>
  );
};

export default FilterModalContent;
